import React, { ButtonHTMLAttributes } from 'react';

import UtilFunctions from '~utils/functions';

import CustomClipLoader from '../CustomClipLoader';

import * as ButtonStyles from './_actionButton.module.scss';

type TActionButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    label: string;
    className?: string;
    isLoading?: boolean;
}

const ActionButton = (props: TActionButtonProps) => {
    const {
        label,
        className,
        isLoading,
        ...otherProps
    } = props;

    const styles = UtilFunctions.Styles.concatClassNames([
        ButtonStyles.container,
        className,
    ]);

    return (
        <button
            className={styles}
            {...otherProps}
        >
            {isLoading
                ? <CustomClipLoader />
                : (
                    <p>
                        {label}
                    </p>
                )
            }
        </button>
    );
};

export default ActionButton;
